import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/database';
import { INVITE_ELIGIBLE_TIERS } from '../../config/house.config';

export default function InvitePage() {
  const { t } = useTranslation();
  const member = useStore(s => s.getMember());
  const createInvite = useStore(s => s.createInvite);
  const invites = useStore(s => s.invites.filter(i => i.issued_by_member_id === member?.id && !i.deleted_at));
  const [copied, setCopied] = useState('');

  if (!member || !INVITE_ELIGIBLE_TIERS.includes(member.access_tier)) {
    return (
      <div className="space-y-4">
        <h1 className="font-serif text-2xl tracking-widest">{t('invite.title')}</h1>
        <p className="text-sm text-charcoal/50 font-sans">{t('invite.notEligible')}</p>
      </div>
    );
  }

  const handleCreate = () => { createInvite(member.id, 1, 14); };
  const handleCopy = (code: string) => { navigator.clipboard.writeText(code); setCopied(code); setTimeout(() => setCopied(''), 2000); };

  return (
    <div className="space-y-6">
      <h1 className="font-serif text-2xl tracking-widest">{t('invite.title')}</h1>
      <button onClick={handleCreate} className="px-6 py-2.5 bg-charcoal text-ivory text-[11px] tracking-widest-xl uppercase font-sans hover:bg-charcoal/90 transition-colors">
        {t('invite.generate')}
      </button>
      {invites.length === 0 && <p className="text-sm text-charcoal/50 font-sans">{t('invite.noInvites')}</p>}
      <div className="space-y-3">
        {invites.map(i => (
          <div key={i.id} className="border border-charcoal/5 p-4 flex items-center justify-between">
            <div>
              <button onClick={() => handleCopy(i.code)} className="font-mono text-sm hover:text-gold transition-colors">{i.code}</button>
              <p className="text-[10px] text-charcoal/30 font-sans mt-1">
                {t('invite.uses')}: {i.used_count}/{i.max_uses} · {t('invite.expires')}: {new Date(i.expires_at).toLocaleDateString()} · {i.status}
              </p>
            </div>
            {copied === i.code && <span className="text-[10px] text-gold font-sans">{t('invite.copied')}</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
